// @flow

import React from 'react';
import {Field, reduxForm} from 'redux-form';
import BasicFormInput from '../BasicFormInput/BasicFormInput';
import DecimalFormInput from '../DecimalFormInput/DecimalFormInput';
import SelectFormInput from '../SelectFormInput/SelectFormInput';

export type Props = {
  configurations: any[],
  apartment?: any,
  formValues?: any,
  onOpenOrder?: Function,
  onUserChange: Function,
};

const ApartmentForm = ({configurations, apartment, formValues, onUserChange, onOpenOrder}: Props) => (
  <div className="ApartmentForm">
    <form>
      <div className="row">
        <div className="small-6 column">
          <Field
            name="objectId"
            label="Lägenhetsnummer"
            onChange={onUserChange}
            component={BasicFormInput}
            type="text" />
          <Field
            name="floor"
            label="Plan"
            onChange={onUserChange}
            component={BasicFormInput}
            type="text" />
          <Field
            name="area"
            label="Yta (kvm)"
            onChange={onUserChange}
            component={DecimalFormInput} />
          <Field
            name="apartmentConfigId"
            label="Lägenhetskonfiguration"
            normalize={value => value ? value.id : null}
            onChange={onUserChange}
            component={SelectFormInput}
            valueKey="id"
            labelKey="name"
            options={configurations} />
        </div>
        <div className="small-6 column">
          <Field
            name="address"
            label="Adress"
            onChange={onUserChange}
            component={BasicFormInput}
            type="text" />
          <Field
            name="zipCode"
            label="Postnummer"
            onChange={onUserChange}
            component={BasicFormInput}
            type="text" />
          <Field
            name="city"
            label="Stad"
            onChange={onUserChange}
            component={BasicFormInput}
            type="text" />
          <div>
            <label>
              Aktiv beställning
            </label>
            {!!onOpenOrder ?
              <button
                onClick={() => onOpenOrder && onOpenOrder()}
                type="button"
                className="expanded button">
                Öppna aktiv beställning
              </button>
              : <span>Ingen beställning på lägenheten</span>
            }
          </div>
        </div>
      </div>
      {apartment && apartment.id && formValues && formValues.apartmentConfigId !== apartment.apartmentConfigId &&
        <div className="callout warning text-center">
          Ändring av lägenhetskonfiguration kommer att rensa ev. produktval
        </div>
      }
    </form>
  </div>
);

export default reduxForm({
  form: 'apartment',
  enableReinitialize: true,
})(ApartmentForm);



// WEBPACK FOOTER //
// ./src/components/ApartmentForm/ApartmentForm.js